/**
 * Socket.IO Singleton Instance
 * Quản lý kết nối Socket.IO cho chat realtime
 */
import { io, Socket } from 'socket.io-client';

// URL của Socket.IO server
const SOCKETIO_URL = process.env.REACT_APP_SOCKETIO_URL || 'https://pmis.mrbhn.com';

// Socket instance singleton và token dùng khi tạo (để phát hiện đổi user sau khi login lại)
let socketInstance: Socket | null = null;
let socketInstanceToken: string | null = null;

/**
 * Lấy token từ localStorage
 */
export const getAuthToken = (): string | null => {
  try {
    const token = localStorage.getItem('access_token');
    if (token) {
      // Đảm bảo token có prefix Bearer
      return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    }
    return null;
  } catch (error) {

    return null;
  }
};

/**
 * Tạo hoặc lấy Socket instance
 * @param forceNew - Force tạo connection mới
 */
export const getSocket = (forceNew = false): Socket | null => {
  const token = getAuthToken();
  
  if (!token) {

    return null;
  }

  // Nếu đã có connection: chỉ dùng lại khi token không đổi (tránh chat vẫn hiện user cũ sau khi login lại)
  if (socketInstance && socketInstance.connected && !forceNew && socketInstanceToken === token) {
    return socketInstance;
  }

  // Disconnect existing socket nếu có (token đổi hoặc force new)
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
    socketInstanceToken = null;
  }

  // Chỉ dùng polling: proxy/nginx thường chưa bật WebSocket cho /socket.io,
  // upgrade lên wss sẽ fail; polling vẫn nhận realtime bình thường.
  const usePollingOnly = process.env.REACT_APP_SOCKETIO_POLLING_ONLY !== 'false';
  socketInstance = io(SOCKETIO_URL, {
    auth: { token },
    transports: usePollingOnly ? ['polling'] : ['polling', 'websocket'],
    upgrade: !usePollingOnly,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    path: '/socket.io',
    withCredentials: false,
  });

  // Event handlers
  socketInstance.on('connect', () => {

  });

  socketInstance.on('disconnect', (reason: string) => {

  });

  socketInstance.on('connect_error', (error: Error) => {

  });

  socketInstance.on('error', (error: Error | string) => {

  });

  socketInstanceToken = token;
  return socketInstance;
};

/**
 * Disconnect Socket
 */
export const disconnectSocket = (): void => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
    socketInstanceToken = null;
  }
};

/**
 * Kiểm tra Socket đã connected chưa
 */
export const isSocketConnected = (): boolean => {
  return socketInstance?.connected ?? false;
};

export default getSocket;
